export const useLivePersonPageChange = () => {
  const { lpTag } = window || {};
  if (lpTag?.newPage) {
    lpTag.newPage(window.location.href, {
      section: [],
      sdes: [],
      taglets: {
        rendererStub: {
          divIdsToKeep: {
            divId: true,
          },
        },
      },
    });
  }
};
